<template>
  <div class="nos-technos-component">
    <div class="central-container">
      <div class="technos-description">
        <h3>Les technologies utilisées par <strong>Flaxeo</strong></h3>
      </div>
      <div class="short-desc">
        Toujours soucieux d’être à la pointe de l’innovation, nous utilisons des solutions de qualité afin d’assurer à nos clients toujours plus de performance.
      </div>
      <ul class="technos-list">
        <li v-for="item in technos" :key="item.index">
          <div>
            <img :alt="item.name" v-lazy="item.image" />
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { BACKEND_API } from "../../config/api";
import { API_ROUTE } from "../../config/api";

export default {
  name: "HomeTechnos",
  data: () => {
    return {
      errorMessage: "",
      technos: "",
      isTechnosReady: false
    };
  },
  mounted() {
    BACKEND_API.get(API_ROUTE.TECHNOS)
      .then(response => {
        this.technos = response.data;
        this.isTechnosReady = true;
      })
      .catch(e => {
        this.errorMessage = e;
      });
  }
};
</script>
<style lang="scss" scoped>
  @import "@/styles/_variables.scss";

  .nos-technos-component {
    margin: 0 auto;
    max-width: 1081px;
    padding: 0 20px;

    .central-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;

      .technos-description {
        text-align: left;

        h3 {
          margin-top: unset;
          font-size: 1.9rem;
          color: $main-text-color;
          background-color: white;
        }
      }
      .short-desc {
        padding: 20px 0;
        background-color: white;
      }
      .technos-list {
        list-style: none;
        display: flex;
        justify-content: space-evenly;
        align-items: center;
        flex-wrap: wrap;
        padding: 0 20px;
        background: #FFFFFF;
        width: calc(100% - 40px);

        li {
          width: calc(33% - 30px);
          min-height: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          padding: 10px 0;

          div {
            display: flex;
            align-items: center;
            justify-content: center;
            max-height: 80px;
            max-width: 300px;

            img {
              max-height: 80px;
              width: 100%;
            }
          }
        }
      }
    }
  }
  @media screen and (max-width: 740px) {
    .nos-technos-component {
      .central-container {
        .technos-list {
          li {
            width: calc(50% - 30px);
          }
        }
      }
    }
  }
  @media screen and (max-width: 640px) {
    .nos-technos-component {
      .central-container {
        align-items: center;
      }
    }
  }
  @media screen and (max-width: 450px) {
    .nos-technos-component {
      .central-container {
        .technos-list {
          li {
            width: calc(100% - 30px);
          }
        }
      }
    }
  }
</style>